import a from "./index438.js";
import { resolveComponent as t, createElementBlock as i, openBlock as p, createElementVNode as o, createTextVNode as m, createVNode as n, withCtx as d } from "vue";
import u from "./index231.js";
const _ = ["data-component"], f = { class: "flex grow" };
function h(e, s, b, g, x, y) {
  const l = t("cs-location-autocomplete"), c = t("ms-loupe"), r = t("cs-primary-button");
  return p(), i("div", {
    class: "relative flex flex-col justify-center p-16 screen-m:pl-24 screen-m:pr-24 screen-l:flex-row screen-l:px-0 screen-l:py-8",
    "data-component": e.$options.name
  }, [
    s[0] || (s[0] = o("div", { class: "mb-10 hyphens screen-l:mb-0 text-text-l" }, [
      o("span", { class: "font-bold" }, "Schön, dass du da bist."),
      o("br"),
      m(" Sag uns bitte kurz, in welchem Ort du suchst. ")
    ], -1)),
    o("div", f, [
      n(l, {
        class: "mr-8 grow screen-l:ml-80",
        autoFocus: !1,
        label: "Ort oder Postleitzahl",
        emptyLabel: "Ort oder Postleitzahl eingeben ...",
        onHighlighted: e.onHighlighted,
        onSelect: e.onSelect
      }, null, 8, ["onHighlighted", "onSelect"]),
      n(r, { onClick: e.redirect }, {
        icon: d(() => [
          n(c)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 8, _);
}
const S = /* @__PURE__ */ u(a, [["render", h]]);
export {
  S as default
};
